import { Icon } from 'antd';

const FontIcon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1298202_50tpkrxdm0f.js',
});

export default FontIcon;
